import axios from 'axios';
import { get } from '@/_helper/storage.jsx';
import { buildPostRequest } from '@/_helper/apiHelper';

export type LogLevel = 'error' | 'warning' | 'info';

type ErrorReportOptions = {
    level?: LogLevel;
};

type ErrorReportProps = <T>(errorLog: T, options?: ErrorReportOptions) => false | Promise<void>;

export const errorReport: ErrorReportProps = (errorLog, options = {}) => {
    const level = options.level ?? 'error';

    if (window.location.hostname === 'localhost') {
        return false;
    }

    const bookingNumber = get('bookingNumber');
    let message = '';

    if (typeof errorLog === 'string') {
        message = errorLog;
    } else if (errorLog instanceof Error) {
        message = JSON.stringify({ name: errorLog.name, message: errorLog.message, stack: errorLog.stack });
    } else {
        message = JSON.stringify(errorLog);
    }

    const sendData = {
        requestType: 'bookingData',
        action: 'logError',
        clientId: 'customerarea',
        requestSource: 'AurumTours-Customerarea',
        hash: get('access_token'),
        data: { message: `[${level}]${bookingNumber !== null ? ` [${bookingNumber}] ` : ' '}${message}` },
    };

    return axios(buildPostRequest(window.$serviceUrl, '/bookingData', sendData))
        .then((response) => response)
        .then(() => {})
        .catch(() => {});
};
